import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { getAppConfigAction } from '~/shared/store/common/actions'

export const useInitAppConfig = (): void => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getAppConfigAction())
  }, [dispatch])
}
